module.exports = "./img/39954a2dd8ee3b645aaa400103c3efeb.jpg";